<template>
  <div>
    <div id="reviews"></div>
    <v-img src="/static/img/home/malina/2.jpg" class="reviews-img">
      <v-carousel class="text-xs-center">
        <v-carousel-item
          dark
          v-for="review in reviews"
          :key="review.id"
        >
          <div class="reviews-mask">
            <div class="reviews-box">
              <div class="reviews-offer">{{ review.h1 }}</div>
              <div class="reviews-sub-offer">{{ review.review }}</div>
              <div class="reviews-name">{{ review.name }}</div>
            </div>
          </div>
        </v-carousel-item>
      </v-carousel>
    </v-img>
  </div>
</template>

<script>
export default {
  data () {
    return {
      reviews: [
        {
          id: 1,
          h1: 'Отзывы',
          review: '"Все очень понравилось! и даже нашлось место для мангала, бассейн водичка теплая и чистая с гидромассажем! А хаммам просто чудо!"',
          name: 'Алена'
        },
        {
          id: 2,
          h1: 'Отзывы',
          review: '"Отдыхали с друзьями в бассейне и в турецкой все просто супер!"',
          name: 'Мария'
        },
        {
          id: 3,
          h1: 'Отзывы',
          review: '"Были с друзьями в сауне пару раз очень понравилась. Близко от центра, отличный турецкая и финская сауна с бассейном. Чисто и достойный сервис. Планируем посетить бильярд)))"',
          name: 'Лилия'
        },
        {
          id: 4,
          h1: 'Отзывы',
          review: '"Отдыхали в сауне на новогодних выходных! Если бы можно было поставила бы 10+. Очень приятная атмосфера и приветливый персонал! Бронировали заранее, за 2 дня, по приезду сауна была прогрета и было все чистенько!"',
          name: 'Ангелина'
        },
        {
          id: 5,
          h1: 'Отзывы',
          review: '"Отличная сауна! Были 5 часов! Чисто в зале, в сауне отлично, бассейн хороший. Все очень удобно устроено! Персонал вежливый, в общем, нам очень понравилось, мы были там не последний раз! И друзьям всем посоветую!"',
          name: 'Анастасия'
        }
      ]
    }
  }
}
</script>

<style scoped>
#reviews {
  position: relative;
  top: -90px;
}

.reviews-img {
  height: 500px;
}

.reviews-mask {
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
}

.reviews-box {
  width: 70%;
  margin: 0px auto;
}

.reviews-offer {
  font-size: 36px;
  font-weight: 900;
  margin-top: 15vh;
  margin-bottom: 40px;
  color: white;
}

.reviews-sub-offer {
  font-size: 19px;
  margin: 40px 0px;
  color: white;
}

.reviews-name {
  font-size: 23px;
  font-weight: 900;
  margin: 40px 0px;
  color: white;
}

/* MEDIA */
/* EXTRA SMALL */
@media (max-width: 600px) {
  .reviews-offer {
    font-size: 24px;
    margin-top: 15vh;
  }

  .reviews-sub-offer {
    font-size: 16px;
  }

  .reviews-name {
    font-size: 19px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/screens/malina/Reviews.vue